/**
 * @file 
 * The Edmunds Service reflects the request to Edmunds site
 * http://developer.edmunds.com/
 */
export class EdmundsService {

    constructor($http, $window, $httpParamSerializer) {
        this.$http = $http;
        this.$httpParamSerializer = $httpParamSerializer;

        this.edmundsApiUrl = '/';
        this.edmundsApiKey = '';

        // look for configuration on window object on init. This allows easy configuration
        // for consumers who do not want to know about angular. This is primarily intended for
        // testing and demo's with non-production backends. It must be set in a <script> tag
        // prior to bootstrapping angular.
        if ($window['jangl'] && $window['jangl'].edmundsApiUrl) {
            this.edmundsApiUrl = $window.jangl.edmundsApiUrl;
        }
        if ($window['jangl'] && $window['jangl'].edmundsApiKey) {
            this.edmundsApiKey = $window.jangl.edmundsApiKey;
        }
    }

    /**
     * Build a url with the source of the provider logo
     * @return String - source logo of Edmunds API
     */
    getEdmundsLogoUrl() {
        if (!this.edmundsApiKey) throw new Error('edmundsApiKey: Is undefined.');
        let params = this.$httpParamSerializer({
            api_key: this.edmundsApiKey,
            size: 300,
            format: 'horizontal',
            retina: true,
            color: 'gray',
        });
        let logoUrl = '//open-api.edmunds.com/api/openapi/v1/logo';
        return `${logoUrl}/?${params}`;
    }

    /**
     * Fetch the details of specific year/model/make car on Edmunds site.
     * @param url - (String) Url detail to be requested on Edmunds site.
     * @return Object - Vehicle styles details.
     */
    getVehicleStyles(url) {
        if (!this.edmundsApiKey) throw new Error('edmundsApiKey: Is undefined.');
        let carUrl = `${this.edmundsApiUrl}/${url}/styles`;

        let request = {
            method: 'GET',
            url: carUrl,
            params: {
                api_key: this.edmundsApiKey,
                fmt: 'json',
                view: 'full'
            },
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return this.$http(request).then((response) => { return response.data });
    }
}

EdmundsService.$inject = ['$http', '$window', '$httpParamSerializer'];



// WEBPACK FOOTER //
// ./app/jangl/EdmundsService.js